.GifPreviewPlaceholder {
  background: var(--primitives-colors-neutral-970);
  position: relative;
  aspect-ratio: 1920 / 1920;
  height: 100%;
  width: 100%;
  min-width: 100%;
  min-height: 370px;
  max-height: 80vh;
  font: var(--font-caption-lg-medium);
  margin-bottom: 32px;

  .desktop & {
    min-width: auto;
    max-width: 500px;
  }
}

.GifBlockPlaceholder {
  background: var(--primitives-colors-neutral-970);
}

.NicheBlockPlaceholder {
  background: var(--primitives-colors-neutral-970);
  height: 210px;
}

.trendingTagsPlaceholder {
  background: var(--primitives-colors-neutral-970);
}

.CreatorTilePlaceholder {
  background: var(--primitives-colors-neutral-970);
  border-radius: 16px;
}

.TagPlaceholder {
  background: var(--primitives-colors-neutral-970);
  height: 35px;
  width: 110px;
  border-radius: 24px;
}
